// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/ProductForm.tsx
// ═══════════════════════════════════════════════════════════════

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ProductApi } from "../lib/api";

export default function ProductForm() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form, setForm] = useState({ name: "", listPrice: "", standardPrice: "", type: "consu" });

  const mutation = useMutation({
    mutationFn: () => ProductApi.create({
      name: form.name,
      listPrice: parseFloat(form.listPrice) || 0,
      standardPrice: parseFloat(form.standardPrice) || 0,
      type: form.type,
    }),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["products"] }); navigate("/products"); },
  });

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-6">New Product</h1>
      <form onSubmit={(e) => { e.preventDefault(); mutation.mutate(); }} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none">
            <option value="consu">Goods</option>
            <option value="service">Service</option>
            <option value="storable">Storable Product</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">List Price</label>
          <input type="number" step="0.01" value={form.listPrice}
            onChange={(e) => setForm({ ...form, listPrice: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cost</label>
          <input type="number" step="0.01" value={form.standardPrice}
            onChange={(e) => setForm({ ...form, standardPrice: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={mutation.isPending}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {mutation.isPending ? "Saving..." : "Save"}
          </button>
          <button type="button" onClick={() => navigate("/products")}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </div>
  );
}
